export default __webpack_public_path__ + "static/media/banner.0eb48a17.png";